///////////////////////////////////////////
// Chart Options
import data from '../../logic/data';

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  events: [], // no hover

  tooltips: {
    // Disable the on-canvas tooltip
    enabled: true,
    // filter: function (tooltipItem) {
    //   return tooltipItem.datasetIndex === 1;
    // },
  },
  /*
    tooltips: {
    backgroundColor: "rgba(0,0,0,0.8)",
    bodyAlign: "left",
    bodyFontColor: "#fff",
    bodySpacing: 2,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    callbacks: {beforeTitle: ƒ, title: ƒ, afterTitle: ƒ, beforeBody: ƒ, beforeLabel: ƒ, …},
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    custom: null,
    displayColors: true,
    enabled: true,
    footerAlign: "left",
    footerFontColor: "#fff",
    footerFontStyle: "bold",
    footerMarginTop: 6,
    footerSpacing: 2,
    intersect: true,
    mode: "nearest",
    multiKeyBackground: "#fff",
    position: "average",
    titleAlign: "left",
    titleFontColor: "#fff",
    titleFontStyle: "bold",
    titleMarginBottom: 6,
    titleSpacing: 2,
    xPadding: 6,
    yPadding: 6,
  }, */
  animation: {
    duration: 0,
  },
  legend: {
    display: true,
    labels: {
      // filter: function (legendItem, data) {
      //   return legendItem.datasetIndex !== 0;
      // },
      // This more specific font property overrides the global property
      fontColor: 'black',
      fontFamily: 'Alef, sans-serif',
    },
  },
  scales: {
    yAxes: [
      {
        position: 'left',
        ticks: {
          beginAtZero: true,

          max: data.examples[data.exampleIdx].yMax,
          // min: data.examples[data.exampleIdx].yMin,
        },
        scaleLabel: {
          display: true,
          labelString: data.examples[data.exampleIdx].yLabel,
          // fontSize: 14,
          fontFamily: 'Alef, sans-serif',
        },
      },
      {
        position: 'right',
        ticks: {
          display: true,
          beginAtZero: true,
          max: data.examples[data.exampleIdx].yMax,
          // min: examples[exampleIdx].yMin,
        },
      },
    ],
    xAxes: [
      {
        ticks: {
          display: false, // don't show x Axis numbers
          beginAtZero: true,
          // max: 20,
        },
        scaleLabel: {
          display: true,
          labelString: data.examples[data.exampleIdx].xLabel,
          // fontSize: 14,
          fontFamily: 'Alef, sans-serif',
        },
      },
    ],
  },
};

//   options: {
//   responsive: true,
//   maintainAspectRatio: false,
//   scales: {
//       xAxes: [{
//           ticks: { display: false },
//           gridLines: {
//               display: false,
//               drawBorder: false
//           }
//       }],
//       yAxes: [{
//           ticks: { display: false },
//           gridLines: {
//               display: false,
//               drawBorder: false
//           }
//       }]
//   }
// }
